class OriginCertificateQuery {
    invoiceNum;
    status;
    statusLabel;
    importerName;
}

export default OriginCertificateQuery